module.exports = __webpack_public_path__ + "static/media/womanProvider.a0524034.png";